import {useRef} from "react";
import { useState, useEffect } from 'react';
import { Card, Spin } from "antd";
import Api from "../../../../services/api";

const AppSumary = (props) => {
  const [appSumary,setAppSumary] = useState(null);
  const [loading,setLoading] = useState(true);
  const prevParamsRef = useRef("");

  useEffect(() => {
    const currentParams = JSON.stringify({
      os: props.os,
      from: props.startDate.format('YYYY-MM-DD'),
      to: props.endDate.format('YYYY-MM-DD'),
      code: props.code,
      country: props.country,
      ad_network: props.adnetwork,
      campaign: props.campaign,
      index_filter: props.filter
    });

    if (prevParamsRef.current === currentParams) return;

    prevParamsRef.current = currentParams;

    setLoading(true)
    Api.get(`api/overview_app/summary?os=${props.os}&from=${props.startDate.format('YYYY-MM-DD')}&to=${props.endDate.format('YYYY-MM-DD')}&code=${props.code}&country=${props.country}&ad_network=${props.adnetwork}&campaign=${props.campaign}&index_filter =${props.filter}`)
    .then(result => {
      
      if(result?.data?.code === 0){
        setAppSumary(result.data.data)
        setLoading(false)
      }
    });
  }, [props.code,props.os,props.reload]);

  return (
    <>
      <style>{`
        .spin-h-100.ant-spin-nested-loading,
        .spin-h-100 .ant-spin-container { height: 100% !important; }
      `}</style>
  	{
      appSumary ? Object.values(appSumary).map((i,k,arr) => (
        <div key={k} className="col-md-3 index-dash" style={{ display: 'flex' }}>
          <div className="w-100 h-100" style={{ height: '117px' }}>
            <Spin spinning={loading} className="w-100 h-100 spin-h-100" style={{ height: '100%' }}>
              <Card size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }} className={`card-summary h-100 ${String(i.title).toLowerCase().includes('attributed installs') ? 'center' : ''}`}>
                <p>{i.title}</p>
                <p className={`money ${k === arr.length - 1 ? 'last' : ''}`}>{i.format}</p>
                <span>Change:<i className={`fa ${i.change_percent > 0 ? 'fa-sort-up' : 'fa-sort-down' }`}></i>{i.change_percent}%</span>
              </Card>
            </Spin>
          </div>
        </div>
      ))
      :
      <>
        {[0,1,2,3].map((k)=> (
          <div key={k} className="col-md-3 index-dash" style={{ display: 'flex' }}>
            <div className="w-100 h-100" style={{ height: '117px' }}>
              <Spin spinning={true} className="w-100 h-100 spin-h-100" style={{ height: '100%' }}>
                <Card className="h-100" size="small" bodyStyle={{ padding: 16 }} style={{ width: '100%', height: '100%' }} />
              </Spin>
            </div>
          </div>
        ))}
      </>
    }
    </>
  )
}
export default AppSumary;
